import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2, HostListener } from '@angular/core';
import { Router } from '@angular/router';
//import { Observable } from 'rxjs';

import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-activity-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.css']
})

export class TimeoutComponent implements OnInit {
    public visible: boolean = false;
    public movedTime: any = Date.now();
    public interval: any = 1000;
    public timeoutLimit: any = 1200000;
    public countdownTimer: any = 30;
    public isCountingDown: boolean = false;

    constructor(private router: Router) {}

    @HostListener('document:mousemove', ['$event']) 
    onMouseMove(e) {
        this.movedTime = Date.now();
    }

    ngOnInit() {

        var timeDiff;
        
        interval(this.interval).pipe(
            takeWhile(() => localStorage.getItem('bearer') && localStorage.getItem('bearer').length > 0)
        ).subscribe(i => {
            timeDiff = Date.now() - this.movedTime;

            if (timeDiff > this.timeoutLimit && !this.isCountingDown) {
                this.isCountingDown = true;
                this.countDown();
            }
        });
    }

    countDown() {
        this.visible = true;

        interval(1000).pipe(
            takeWhile(() => this.visible)
        ).subscribe(i => {
            if (this.countdownTimer <= 0) {
                this.logout();
            } else {
                this.countdownTimer -= 1;
            }
        });
    }

    continue() {
        this.visible = false;
        this.isCountingDown = false;
        this.movedTime = Date.now();
        this.countdownTimer = 30;
    }

    logout() {
        localStorage.clear();

        this.visible = false;
        this.isCountingDown = false;
        this.movedTime = Date.now();
        this.countdownTimer = 30;
        
        this.router.navigateByUrl('login');
    }

}
